import PropTypes from 'prop-types';

// https://github.com/facebook/prop-types/issues/230
export function tupleOf(typeCheckers) {
  return PropTypes.arrayOf(
    (value, index, ...rest) => typeCheckers[index](value, index, ...rest)
  );
}

export const brokerTuple = tupleOf([
  PropTypes.string.isRequired,
  PropTypes.number.isRequired
]);

export const brokerOption = PropTypes.shape({
  label: PropTypes.string.isRequired,
  value: PropTypes.number.isRequired
});

export const countryStatePropType = PropTypes.shape({
  displayName: PropTypes.string,
  code: PropTypes.string
});

export const countryPropType = PropTypes.shape({
  name: PropTypes.string,
  id: PropTypes.number,
  stateLabel: PropTypes.string,
  zipLabel: PropTypes.string,
  hasCounty: PropTypes.bool,
  countryStates: PropTypes.arrayOf(countryStatePropType)
});

export const countryListPropType = PropTypes.arrayOf(countryPropType);
